import { render, staticRenderFns } from "./start-new-chat-dialog.vue?vue&type=template&id=9d70dbba&scoped=true&"
import script from "./start-new-chat-dialog.vue?vue&type=script&lang=js&"
export * from "./start-new-chat-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d70dbba",
  null
  
)

export default component.exports